/**
 * `value` as a share of `total`, as a percentage string. An empty total has
 * no share to state, so it answers the em dash rather than a zero that would
 * read as "none of many".
 */
export function formatShare(
  value: number,
  total: number,
  options?: { digits?: number },
): string {
  if (total <= 0) return "\u2014";
  const digits = options?.digits ?? 0;
  const percent = (value / total) * 100;
  return `${percent.toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: 0 })}%`;
}
